/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsplaces1Inputs */

const en_statsplaces1 = /** @type {(inputs: Statsplaces1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places`)
};

const de_statsplaces1 = /** @type {(inputs: Statsplaces1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orte`)
};

/**
* | output |
* | --- |
* | "Places" |
*
* @param {Statsplaces1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsplaces1 = /** @type {((inputs?: Statsplaces1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsplaces1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsplaces1(inputs)
	return de_statsplaces1(inputs)
});
export { statsplaces1 as "statsPlaces" }